export const CoachingTranslationDictionary = {
    // main page
    MyCoaching: "My Coaching",
    Active: "Active",
    New: "New",
    CoachingSession: "Coaching session",
    RequiresYourReview: "Requires your review",
    CompletedSessions: "Completed sessions",
    NoActiveSessionMessage: "You have no sessions to review",
    AcknowledgedOn: "Reviewed on {0}",
    CompletedOn: "Completed on {0}",
    NoCompletedSessionsMessage: "You have no completed coaching sessions.",

    ErrorCreatingSession: "Coaching session failed to open. Try again",
    ErrorUserNotAuthenticated: "You must be logged in to access coaching sessions",

    // complete session
    CompleteSession: "Complete session",
    CompleteSessionTitle: "Complete session?",
    CompleteSessionMessage: "By completing this session, you confirm that you've reviewed the coaching materials. Keep up the great work.",
    FeedbackPlaceholder: "Leave feedback (optional)",
    Cancel: "Cancel",
    ErrorCompletingSession: "Failed to complete session. Try again",
    NoCompletePermissionMessage: "You don't have permission to complete this coaching session",

    // session completed page
    Completed: "Completed",
    SessionCompletedTitle: "Session complete",
    SessionCompletedMessage: "Coaching session completed. Drive safe out there.",
    BackToMyCoaching: "Back to My Coaching",

    // comments section
    Comments: "Comments",
    NoCommentsMessage: "No comments yet",
    AddCommentPlaceholder: "Add a comment",
    AddComment: "Add comment",
    SyncPending: "Sending...",
    CompletionSyncPending: "Syncing...",
    SyncFailed: "Couldn't sync",
    Synchronized: "Synchronized",
    CommentDroppedSessionCompleted: "This coaching session is closed. Because you were offline at the time, your pending comments couldn't be synced and added.",
    CommentDroppedNoPermission: "Your comment could not be sent. You are not authorized to add comments to this session.",
    CompletionDroppedNoPermission: "Your session completion could not be synced. You are not authorized to complete this session.",

    // safety rank card
    YourSafetyPerformance: "Your safety performance",
    NoSafetyDataAvailable: "No safety data available",
    HighestPerformingArea: "Highest performing area: {0}",
    Cornering: "Cornering",
    Acceleration: "Acceleration",
    Braking: "Braking",
    Speeding: "Speeding",
    Tailgating: "Tailgating",

    // rank pill
    Excellent: "Excellent",
    Good: "Good",
    Moderate: "Moderate",
    High: "High",
    Critical: "Critical",

    // exception event card
    MapUnavailable: "Map unavailable",
    Limit: "Limit",

    // exception event details sheet
    EventDetails: "Event details",
    Location: "Location",
    ExceptionRule: "Exception rule",
    Vehicle: "Vehicle",
    Date: "Date",
    Duration: "Duration",
    Distance: "Distance",
    SpeedChange: "Speed change",
    PostedRoadSpeed: "Posted road speed",
    MaximumDrivingSpeed: "Maximum driving speed",
    PreviousEvent: "Previous event",
    NextEvent: "Next event",

    // speed change indicator (harsh braking / acceleration events)
    SpeedChangeIn: "in {0}s"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in CoachingTranslationDictionary) {
        r.push(CoachingTranslationDictionary[prop]);
    }
    return r;
};

export const CoachingTranslations = getTranslations();
